module.exports = __webpack_public_path__ + "img/vue1-corpsarr_noir.ce47af37.png";